// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1x3Z9","alertIcon":"ConfirmModal_alertIcon__iynSq"};